module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-posthog/gatsby-browser.js'),
      options: {"plugins":[],"apiKey":"phc_sglKCHcViNzsNo4w1ay5t4kCz3hzVQA5HYHWvLgglec","apiHost":"https://us.i.posthog.com","head":true,"isEnabledDevMode":false,"initOptions":{"persistence":"localStorage+cookie","custom_campaign_params":["utm_kw","utm_keyword","utm_campaign_id"],"disable_session_recording":true,"person_profiles":"always"}},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
